import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function MistakesSection() {
  const mistakes = ['Miras el reloj y empiezas a negociar con el tiempo.', 'Agarras el celular «solo un segundo».', 'Pruebas un truco distinto cada noche (té, melatonina, respiración random).', 'Te quedas en la cama frustrada, dando vueltas, peleando.'];
  return <section className="w-full py-20 md:py-32 px-6 bg-navy relative overflow-hidden" data-id="element-69">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-warm-radial opacity-30 pointer-events-none" data-id="element-70" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-72">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-cream mb-12 text-center leading-tight" data-id="element-73">
            LO QUE LA MAYORÍA HACE <br data-id="element-74" />
            <span className="text-gold-dim text-2xl md:text-4xl" data-id="element-75">
              (Y POR ESO SE QUEDA PEGADA)
            </span>
          </h2>

          <div className="space-y-6" data-id="element-76">
            <p className="text-lg md:text-xl text-cream-muted text-center mb-8" data-id="element-77">
              Cuando te despiertas, haces una de estas:
            </p>

            <div className="grid gap-4" data-id="element-78">
              {mistakes.map((mistake, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className="flex items-start p-4 rounded-lg bg-navy-light/50 border border-navy-lighter" data-id="element-79">
                  <span className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-navy border border-gold/30 text-gold font-serif font-bold mr-4" data-id="element-80">
                    {index + 1}
                  </span>
                  <p className="text-lg text-cream-muted" data-id="element-81">{mistake}</p>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="mt-12 p-8 bg-gradient-to-br from-gold/10 to-navy border border-gold/30 rounded-xl text-center" data-id="element-82">
              <h3 className="text-gold font-bold text-lg uppercase tracking-wider mb-3" data-id="element-83">
                La Consecuencia
              </h3>
              <p className="text-xl md:text-2xl text-cream font-serif leading-relaxed" data-id="element-84">
                Tu cerebro aprende que a las 3AM hay actividad. <br data-id="element-85" />
                <span className="text-gold-bright" data-id="element-86">
                  Y si hay actividad… no hay sueño.
                </span>
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}